import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const attendanceStatuses = [
  "pending",
  "absent",
  "absent_schcon",
  "absent_alert",
  "attended",
  "pending_absence",
];

/**
 * Fetches attendance data for a child based on the given parameters.
 *
 * @param {Object} params - The parameters required to fetch child attendances.
 * @param {number} params.member_id - The ID of the child (member).
 * @param {string} params.start_month - The start month in `YYYY-MM` format. (e.g., "2025-01")
 * @param {string} params.end_month - The end month in `YYYY-MM` format. (e.g., "2025-03")
 * @param {string[]} params.statuses - An array of attendance statuses.
 * Allowed values: "pending", "absent_reservation", "absent", "absent_schcon", "absent_alert", "attended", "pending_absence"
 * @param {0 | 1} params.reschedulable_only - Whether to fetch only reschedulable classes. Use 1 for true, 0 for false.
 * @param {0 | 1} params.bus_only - Whether to fetch only return bus. Use 1 for true, 0 for false.
 * @param {0 | 1} params.valid_only - Whether to fetch only valid schedules. Use 1 for true, 0 for false.
 *
 * @returns {Promise<ChildAttendancesResponse>} A promise that resolves to the child's attendance data.
 */
export const getMemberAttendances = ({ member_id, ...params }) => {
  return api.get(`/admin/child-schedules/${member_id}`, {
    params,
  });
};

export const getMemberAttendancesQueryOptions = params => {
  return queryOptions({
    queryKey: ["memberAttendances", params],
    queryFn: () => getMemberAttendances(params),
  });
};

export const useMemberAttendances = ({ queryConfig, ...params }) => {
  return useQuery({
    ...getMemberAttendancesQueryOptions(params),
    ...queryConfig,
  });
};
